import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import ManagerSchedule from './ManagerSchedule'
import MetaTags from 'react-meta-tags'

class SchedulePage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            userGroup: '',
        }
    }

    UNSAFE_componentWillMount() {
        // this.loadUser()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/api/userInfo`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ userGroup: res.data.user.group })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        return (
            <div className="schedulePage_wrap">
                <MetaTags>
                    <title>
                        투명한 집짓기 하우스플래너 - 하우스플래너는 예산사용, 시공과정과 결과 모두 투명하게 공개합니다.
                    </title>
                </MetaTags>
                <ManagerSchedule history={this.props.history} />
            </div>
        )
    }
}

export default withCookies(SchedulePage)



// WEBPACK FOOTER //
// ./Src/Containers/Schedule/SchedulePage.js